<template>
    <Form @submit="createOrUpdate" :key="createMode">
        <div class="forbidden-name-form flex flex-column overflow-hidden gap-3">
            <CustomInputText name="name" :label="$t('message.forbiddenName.name')" required
                v-model="editedName.name" class="w-10"
                :customErrorMessage="getRequiredMessage(editedName.name)"
                noPlaceholder />
            <div class="forbidden-name-buttons flex align-self-center gap-4 mt-6">
                <CustomButton :label="$t('message.other.save')" type="submit" />
                <CustomButton v-if="createMode" :label="$t('message.other.cancel')" secondary
                    @click="hideForm" />
                <CustomButton v-else :label="$t('message.other.delete')" secondary @click="deleteName"
                    :disabled="createMode" />
            </div>
        </div>
    </Form>
</template>

<script>
import {Form} from "vee-validate";
import { createOrUpdateForbiddenName, deleteForbiddenName } from "@/swagger/vue-api-client";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomSelectOneHorseBreed from "@/components/form/CustomSelectOneHorseBreed.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import _ from 'lodash';
import CustomButton from "@/components/form/CustomButton.vue";
import { ValidateUtils } from "@/utils/ValidateUtils";
import CustomInputText from "@/components/form/CustomInputText.vue";

export default {
    name: "ForbiddenNameForm",
    components: {
        CustomCheckbox,
        CustomSelectOneHorseBreed,
        CustomInputText,
        CustomInputNumber,
        CustomButton,
        Form
    },

    props: {
        selectedName: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            editedName: {
                name: "",
            },
            loading: false,
            createMode: true,
            showErrorMessages: false,
        };
    },

    emits: ["change-element", "createMode", "hideForm"],

    mounted() {
        this.$emit("createMode", this.createMode);
    },

    methods: {
        validateData() {
            let isCorrect = ValidateUtils.validateNotEmpty(this.editedName, ["name"]);
            this.showErrorMessages = !isCorrect;
            return isCorrect;
        },
        getRequiredMessage(value) {
            if (this.showErrorMessages && (value === null || value === "")) {
                return this.$t("message.validations.required");
            }
            return "";
        },
        notifyChange() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.dataSaved'),
                life: 3000,
            });
        },
        notifyDelete() {
            this.$emit("change-element");
            this.$toast.add({
                severity: "success",
                summary: this.$t('message.other.success'),
                detail: this.$t('message.other.elementDeleted'),
                life: 3000,
            });
        },
        notifyError(error) {
            const message = error.response?.data?.message || this.$t('unknownError');
            this.$toast.add({
                severity: "error",
                summary: this.$t('message.other.error'),
                detail: message,
                life: 5000,
            });
        },
        async createOrUpdate() {
            if (this.validateData()) {
                try {
                    await createOrUpdateForbiddenName({ body: this.editedName });
                    this.notifyChange();
                } catch (error) {
                    this.notifyError(error);
                }
            }
        },
        async deleteName() {
            try {
                await deleteForbiddenName({ id: this.editedName.id });
                this.notifyDelete();
                this.showErrorMessages = false;
            } catch (error) {
                this.notifyError(error);
            }
        },
        hideForm() {
            this.$emit("hideForm");
        },
    },

    watch: {
        selectedName(newValue) {
            this.editedName = _.cloneDeep(newValue);
            this.createMode = newValue.id === null || newValue.id === undefined || isNaN(newValue.id);
            this.$emit("createMode", this.createMode);
        },
    },
};
</script>

<style lang="scss">
.forbidden-name-form {
    .custom-input-text, .custom-input-number {
        padding-left: 170px;
        .custom-label {
            text-align: right;
            z-index: 999;
            position: absolute;
            transform: translateX(-100%);
            left: 160px;
        }
    }
    @media screen and (max-width: 650px) {
        align-items: end;
        .custom-input-text, .custom-input-number {
            padding-left: 70px;
            .custom-label {
                left: 60px;
            }
        }
    }
}
</style>
